module.exports = __webpack_public_path__ + "img/pin-2017.d6a83a96.png";